import { DeliveryDining as DeliveryIcon } from "@mui/icons-material";
import { Box, Chip, CircularProgress, Switch, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAceptaDelivery } from "store/slices/sucursal";

const SwitchDelivery = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [estado, setEstado] = useState(false);
  const { aceptaDelivery, isLoading } = useSelector((state) => state.sucursal);

  useEffect(() => {
    setEstado(aceptaDelivery);
  }, [aceptaDelivery]);

  const handleChange = (event) => {
    const newEstado = event.target.checked;
    setEstado(newEstado);
    dispatch(
      updateAceptaDelivery({
        estado: newEstado,
      })
    );
  };

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        width: "100%",
        py: 0.5,
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: estado ? theme.palette.info.main : theme.palette.text.secondary,
        }}>
        <DeliveryIcon fontSize="small" />
        <Typography variant="body2" fontWeight={500}>
          Delivery
        </Typography>
      </Box>

      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <Chip
          label={estado ? "Disponible" : "No disponible"}
          size="small"
          sx={{
            backgroundColor: estado ? theme.palette.info.main : theme.palette.grey[400],
            color: theme.palette.common.white,
            fontWeight: 600,
            fontSize: "0.75rem",
            height: 24,
          }}
        />
      </Box>

      <Switch
        checked={estado}
        onChange={handleChange}
        size="small"
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.info.main,
            "&:hover": {
              backgroundColor: `${theme.palette.info.main}14`,
            },
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: theme.palette.info.main,
          },
        }}
      />
    </Box>
  );
};

export default SwitchDelivery;
